export const nanopaySelectors = {
  isCADAndPaymentMethodNanopaySelector(currency, paymentMethodType) {
    return currency === 'CAD' && paymentMethodType === 'nanopay';
  },
};
